import React from 'react';
import {SvgPdf, SvgVideo, SvgPage} from  '../Svg.js'
import { Link } from 'react-router-dom';

const Solucoes = () => {
  return (
<div>
  <div id="titulo">
    <h1>Nossas Soluções</h1>
  </div>	
  <div id = "texto2" class='row'>
		<div class='col-4'>
			<div class='card1'>
				<h2>Serviços</h2>
				<p>			Instalação, Implantação, Passagem de Dados, Suporte Remoto, Visita Técnica, Treinamento e Adequações. </p>
				<a href="info/Criar Tecnologia - Soluçoes de Serviços.pdf"><SvgPdf/></a>
				<Link to="/video2"><SvgVideo/></Link>
			</div>
		</div>
		<div class='col-4'>
			<div class='card1'>
				<h2>Infraestrutura</h2>
				<p>Rede de Computadores, Telefonia, Internet, Câmeras, Som Ambiente, Painéis de Informação, Energia e Meios de Pagamentos.</p>
				<a href="info/Criar Tecnologia - Soluçoes de Infraestrutura.pdf"><SvgPdf/></a>
				<Link to="/video3"><SvgVideo/></Link>
			</div>
		</div>
		<div class='col-4'>
			<div class='card1'>
				<h2>Equipamentos</h2>
				<p>Automação Comercial, Informática, Rede, Câmera, Telefonia, Painéis de Informação, Som Ambiente, Energia, Meio de Pagamentos e Suprimentos.</p>
				<a href="info/Criar Tecnologia - Soluçoes de Equipamentos.pdf"><SvgPdf/></a>
				<Link to="/video4"><SvgVideo/></Link>
			</div>
		</div>     
		<div class='col-12'>
			<div class='card1'>
				<h2>Programas e Sistemas</h2>
				<p>PDV, Retaguarda, Administrativo, Emissores Fiscais (ECF,  SAT,  NFC-e,  RPS NFS-e NF-e.), Programas Complementares (CEP,  Cadastro,  Identificador de Chamadas,  SiTef Criar,  Gerador de Documentos, Gráficos e Relatórios (PDF, CSV, TXT, HTML),  Controlador de Cozinha,  Controlador de Balança,  Controlador de Micro Terminais,  Painel de Informação,  Envia e-mail,  Consulta Preço,  Balãozinho.</p>
				<a href="info/Criar Tecnologia - Soluçoes de Programas e Sistemas.pdf"><SvgPdf/></a>
				<Link to="/video5"><SvgVideo/></Link>
				<Link to="/programas" id=""><SvgPage/></Link>
			</div>
		</div>
    <p>Nós instalamos infraestrutura, equipamentos e softwares, para atender às necessidades específicas de cada cliente.</p>

	</div>
</div>


      )
      };

export default Solucoes;
